export const getFileType = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex !== -1
    ? fileName.slice(lastDotIndex + 1).toLowerCase()
    : '';
};